import React from "react";
import { getInventorySignClassName } from "../inventorySignStyles";

const toNumber = (value) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const InventoryRoundOffValue = ({ roundOff }) => {
  const value = toNumber(roundOff);

  if (value === 0) {
    return <span>₹ 0.00</span>;
  }

  const isPositive = value > 0;

  return (
    <span className={getInventorySignClassName(isPositive)}>
      {isPositive ? "+" : "-"} ₹ {Math.abs(value).toFixed(2)}
    </span>
  );
};

export default InventoryRoundOffValue;
